<h1 mat-dialog-title>{{ 'executionEdit.' + data.type + 's.title' | translate }}</h1>
<form>

  <div mat-dialog-content class="qualificates-theme" style="min-height: 10vh;">

    <div fxLayout="column" fxLayout.xs="column" class="flexwrap">

      <div fxFlex="50" fxFlex.lt-md="100%">

        <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

          <div fxFlex="50" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'executionEdit.' + data.type + 's.responsible.label' | translate }}</mat-label>
              <mat-select name="responsible" [(ngModel)]="data.bioindicator.responsible">
                @for (responsible of bioindicatorResponsibles; track responsible) {
                  <mat-option [value]="responsible.id">
                    {{ 'bioindicatorResponsibleType.' + responsible.translation | translate }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div fxFlex="100" fxFlex.lt-md="100%">
        <mat-radio-group class="vertical-radio-group" [ngModel]="optionSelected" [ngModelOptions]="{standalone: true}">
          @for (item of options; track item) {
            <mat-radio-button class="vertical-radio-button" [value]="item"
              (change)="onOptionChange($event)">
              {{ 'executionEdit.' + data.type + 's.options.' + item + '.label' | translate }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </div>

      <div fxFlex="100" fxFlex.lt-md="100%">

        @if (optionSelected == 'cert') {
          <div>
            <button mat-raised-button color="primary" (click)="uploadCertificate.click()">
              {{ 'button.upload-certificate' | translate }}
            </button>
            <input accept="application/pdf" hidden type="file" (change)="uploadCertificateBioindicator($event)"
              #uploadCertificate>
            @for (cert of data.bioindicator.certificates; track cert; let indexCert = $index) {
              <div>
                {{ cert.filename }}
                @if (cert.id != null) {
                  <button mat-icon-button (click)="downloadAttachment(cert)">
                    <mat-icon>cloud_download</mat-icon>
                  </button>
                }
                @if (cert.id == null) {
                  <button mat-icon-button (click)="downloadAttachmentLocal(cert)">
                    <mat-icon>cloud_download</mat-icon>
                  </button>
                }
                <button mat-icon-button (click)="removeAttachment(indexCert)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        }

        @if (optionSelected == 'batch') {
          <div>
            @for (batch of data.bioindicator.batchs; track batch; let indexBatch = $index) {
              <div fxLayout="row" fxLayout.xs="column" class="flexwrap"
                >
                <div fxFlex="5" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'executionEdit.' + data.type + 's.number.label' | translate }}</mat-label>
                    <input matInput
                      name="batchNumber{{indexBatch}}" [ngModel]="(indexBatch + 1)" disabled="true">
                  </mat-form-field>
                </div>
                <div fxFlex="45" fxFlex.lt-md="100%">
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'executionEdit.' + data.type + 's.batch.label' | translate }}</mat-label>
                    <input matInput
                      name="batchId{{indexBatch}}" [(ngModel)]="batch.batchId">
                    <mat-error>
                      {{ 'executionEdit.' + data.type + 's.batch.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div fxFlex="45" fxFlex.lt-md="100%">
                  <mat-form-field>
                    <mat-label>{{ 'executionEdit.' + data.type + 's.expiryDate.label' | translate }}</mat-label>
                    <input matInput [matDatepicker]="expiryDate" name="expiryDate{{indexBatch}}"
                      [(ngModel)]="batch.expiryDate">
                    <mat-datepicker-toggle matSuffix [for]="expiryDate"></mat-datepicker-toggle>
                    <mat-datepicker #expiryDate >
                    </mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex="5" fxFlex.lt-md="100%">
                  @if (data.bioindicator.batchs.length > 1) {
                    <button mat-icon-button color="accent" (click)="removeBatch(indexBatch)"
                      >
                      <mat-icon>clear</mat-icon>
                    </button>
                  }
                </div>
              </div>
            }
            <div>
              <button mat-raised-button color="primary" (click)="newBatch()">
                {{ 'button.new' | translate }}
              </button>
            </div>
          </div>
        }

        @if (optionSelected == 'reason') {
          <div>
            <textarea rows="5" matAutosizeMinRows="5" matInput
              placeholder="{{ 'executionEdit.' + data.type + 's.reason.label' | translate }}"
            [(ngModel)]="data.bioindicator.reason" name="reason" required style="resize: none;"></textarea>
          </div>
        }

      </div>

      @if (data.type == 'bioindicator') {
        <div fxFlex="100" fxFlex.lt-md="100%">
          <br />
          <span>{{'executionEdit.' + data.type + 's.equipments.title' | translate}}</span>
          <br />
          <mat-radio-group [(ngModel)]="hasEquipmentData" name="hasEquipmentData">
            <mat-radio-button [value]="true" (change)="onHasEquipmentData($event)">
              {{'common.yes' | translate}}
            </mat-radio-button>
            <mat-radio-button [value]="false" (change)="onHasEquipmentData($event)">
              {{'common.no' | translate}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      }

      @if (!hasEquipmentData) {
        <div fxFlex="100" fxFlex.lt-md="100%">
          <br /><br />
        </div>
      }

      @if (hasEquipmentData) {
        <div fxFlex="100" fxFlex.lt-md="100%">
          <br />
          <div fxLayout="row" fxLayout.xs="column" class="flexwrap">
            <div fxFlex="50" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionEdit.' + data.type + 's.equipments.table.equipment.label' | translate }}</mat-label>
                <input matInput
                  name="equipment" [(ngModel)]="data.bioindicator.equipments[0].equipment" [errorStateMatcher]="matcher">
                <mat-error>
                  {{ 'executionEdit.' + data.type + 's.equipments.table.equipment.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionEdit.' + data.type + 's.equipments.table.serialNum.label' | translate }}</mat-label>
                <input matInput
                  name="serialNum" [(ngModel)]="data.bioindicator.equipments[0].serialNum" [errorStateMatcher]="matcher">
                <mat-error>
                  {{ 'executionEdit.' + data.type + 's.equipments.table.serialNum.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionEdit.' + data.type + 's.equipments.table.internalId.label' | translate }}</mat-label>
                <input matInput
                  name="internalId" [(ngModel)]="data.bioindicator.equipments[0].internalId"
                  [errorStateMatcher]="matcher">
                <mat-error>
                  {{ 'executionEdit.' + data.type + 's.equipments.table.internalId.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'executionEdit.' + data.type + 's.equipments.table.certificateNum.label' | translate }}</mat-label>
                <input matInput
                  name="certificateNum" [(ngModel)]="data.bioindicator.equipments[0].certificateNum"
                  [errorStateMatcher]="matcher">
                <mat-error>
                  {{ 'executionEdit.' + data.type + 's.equipments.table.certificateNum.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-md="100%">
              <mat-form-field style="width: 95%;">
                <mat-label>{{ 'executionEdit.' + data.type + 's.equipments.table.calibrateDate.label' | translate }}</mat-label>
                <input
                  matInput [matDatepicker]="calibrateDate" name="calibrateDate"
                  [ngModel]="data.bioindicator.equipments[0].calibrateDate"
                  (dateInput)="saveDate('calibrateDate', $event)" (dateChange)="saveDate('calibrateDate', $event)">
                <mat-datepicker-toggle matSuffix [for]="calibrateDate"></mat-datepicker-toggle>
                <mat-datepicker #calibrateDate >
                </mat-datepicker>
                <mat-error>
                  {{ 'executionEdit.' + data.type + 's.equipments.table.calibrateDate.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="50" fxFlex.lt-md="100%">
            </div>
            <div fxFlex="50" fxFlex.lt-md="100%">
            </div>
            <div fxFlex="50" fxFlex.lt-md="100%">
              <button mat-raised-button (click)="uploadCertificate.click()" color="accent">{{ 'button.upload-certificate'
              | translate }}</button>
              <div fxFlex="5px"></div>
              @if (showDownloadCertificateEquipment()) {
                <button mat-raised-button
                  (click)="downloadCertificateEquipment()" color="accent">{{ 'button.download-certificate' | translate
                }}</button>
              }
              <input accept="application/pdf" hidden type="file" (change)="uploadCertificateToEquipment($event)"
                #uploadCertificate>
            </div>
          </div>
        </div>
      }

    </div>
  </div>

  <div mat-dialog-actions class="thermal-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <div fxFlex="5px"></div>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>